import type { Template, FindingGroup, FindingLabel } from '@/models/template';
import type { Finding } from '@/models/report';
import { joinFindingValues } from '@/features/report/Findings/FindingInput/utils/statements';
import type { FindingGroupDisplay } from '../types/reportDetail';

/**
 * Combines template finding groups with actual report values
 * to produce display-ready data for FindingsSection.
 */
export function buildFindingGroups(
  template: Template | undefined,
  reportFindings: Finding[]
): FindingGroupDisplay[] {
  if (!template?.findingGroups?.length) return [];

  const valueByClass = joinFindingValues(reportFindings);

  return [...template.findingGroups]
    .sort((a: FindingGroup, b: FindingGroup) => (a.index ?? 0) - (b.index ?? 0))
    .map((group: FindingGroup) => {
      const items = [...(group.findingLabels ?? [])]
        .sort(
          (a: FindingLabel, b: FindingLabel) => (a.index ?? 0) - (b.index ?? 0)
        )
        .map((fl: FindingLabel) => ({
          key: fl.uuid ?? fl.findingClass,
          label: fl.label,
          value: valueByClass.get(fl.findingClass) ?? null,
        }));

      return { groupLabel: group.label, style: group.style, items };
    });
}
